import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-expand.tsx
/**
* icon.24.expand
*
* Represents the action of "zooming in", "maximizing", "full-screen-ing" an element. For instance used on the full-screen button in presentation mode.
*
* Keywords: diagonal, arrows, outward, resize, maximize, bidirectional, opposing, fullscreen
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJtMTcgNy43MDctMy4xNDYgMy4xNDdhLjUuNSAwIDAgMS0uNzA4LS43MDhMMTYuMjkzIDdIMTMuNWEuNS41IDAgMCAxIDAtMWg0YS41LjUgMCAwIDEgLjUuNXY0YS41LjUgMCAwIDEtMSAwem0tNi44NTQgNS40NGEuNS41IDAgMCAxIC43MDguNzA3TDcuNzA3IDE3SDEwLjVhLjUuNSAwIDAgMSAwIDFoLTRhLjUuNSAwIDAgMS0uNS0uNXYtNGEuNS41IDAgMCAxIDEgMHYyLjc5M3oiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-767
*/
const Icon24Expand = memo(function Icon24Expand(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "m17 7.707-3.146 3.147a.5.5 0 0 1-.708-.708L16.293 7H13.5a.5.5 0 0 1 0-1h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0zm-6.854 5.44a.5.5 0 0 1 .708.707L7.707 17H10.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v2.793z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Expand };

//# sourceMappingURL=icon-24-expand.js.map